<template>
  <div
    v-if="!loading"
    class="pc-colour-swatches"
    :class="{
      [$class('loading')]: loading,
    }"
  >
    <div
      v-for="(swatch, index) in swatches"
      :key="index"
      class="pc-colour-swatches__swatch"
      :class="{
        [$class('active')] : swatch.handle === product.handle,
        'pc-colour-swatches__swatch--white': getSwatchColour(swatch) === '#ffffff'
      }"
      @click="updateProduct(swatch)"
    >
      <div
        class="pc-colour-swatches__swatch-inner"
        :style="`background-color: ${getSwatchColour(swatch)}`"
      />
    </div>

    <a
      v-if="hiddenSwatchesCount > 0"
      class="pc-colour-swatches__swatch-count text-label-s"
      :href="product.url"
    >
      +{{ hiddenSwatchesCount }}
    </a>
  </div>
</template>

<script>

/**
 * Vue: Product Card Colour swatches (pc-colour-swatches)
 * -----------------------------------------------------------------------------
 * Displays swatches for related product colourways, that link to that product.
 *
 * @param {Number, String} colourFamilySize - Number of colourways for the product.
 * @param {Object} product - Product Object.
 *
 */

export default {
  name: 'PCColourSwatches',

  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    swatches: {
      type: Array,
      default: () => [],
    },
    product: {
      type: [Object, Boolean],
      default: false,
    },
    colourFamilySize: {
      type: [Number, String],
      default: 6,
    },
    hiddenSwatchesCount: {
      type: Number,
      default: 0,
    },
  },

  emits: ['product-update'],

  methods: {

    /**
     * Helper function that returns the colour code.
     * @param {Object} swatch - Product object.
     * @returns {String}
     */
    getSwatchColour(swatch) {
      const colour = swatch.metafields.find(field => field.name === 'swatch_code')

      return colour ? colour.value : ''
    },

    /**
     * Returns the current products swatch name.
     * @returns {String}
     */
    familySize() {
      const size = this.product?.metafields?.find(
        field => field.name === 'colour_family_name',
      )

      if (size?.value) {
        return parseInt(size.value)
      }

      if (typeof(this.colourFamilySize) === 'string') {
        return parseInt(this.colourFamilySize)
      }

      return this.colourFamilySize
    },

    /**
     * Updates the product id.
     * @param {Object} - Product object.
     */
    updateProduct(swatch) {
      if (!swatch) {
        return
      }

      if (swatch.handle === cnvs.page.handle) {
        return
      }

      this.$emit('product-update', swatch)
    },
  },
}
</script>

<style lang="scss">
@import './pc-colour-swatches';
</style>
